var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSausage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.272 3.11641C13.323 1.33182 15.6216 0.73713 17.4062 1.78812L17.631 1.9205C19.4156 2.97149 20.0103 5.27018 18.9593 7.05476L10.5692 21.3012C9.51821 23.0858 7.21953 23.6805 5.43494 22.6295L5.21016 22.4971C3.42558 21.4461 2.83088 19.1474 3.88187 17.3628L12.272 3.11641ZM16.645 3.08063C15.5743 2.45004 14.1951 2.80685 13.5645 3.8776L5.17438 18.124C4.54378 19.1948 4.9006 20.574 5.97135 21.2046L6.19614 21.337C7.26689 21.9675 8.6461 21.6107 9.27669 20.54L17.6668 6.29357C18.2974 5.22282 17.9406 3.84361 16.8698 3.21301L16.645 3.08063Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84166 13.1834C7.16768 12.9279 7.6391 12.9851 7.89461 13.3111L9.33394 15.1476C9.58945 15.4736 9.5323 15.945 9.20628 16.2005C8.88027 16.456 8.40885 16.3989 8.15333 16.0729L6.71401 14.2364C6.45849 13.9104 6.51565 13.439 6.84166 13.1834Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88519 10.0898C9.1909 9.81029 9.66529 9.83153 9.94479 10.1372L11.3153 11.6363C11.5948 11.942 11.5736 12.4164 11.2679 12.6959C10.9622 12.9754 10.4878 12.9541 10.2083 12.6484L8.83774 11.1494C8.55824 10.8437 8.57949 10.3693 8.88519 10.0898Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9721 6.95935C11.2779 6.67985 11.7522 6.7011 12.0317 7.0068L13.4023 8.50585C13.6818 8.81155 13.6605 9.28595 13.3548 9.56544C13.0491 9.84494 12.5747 9.8237 12.2952 9.51799L10.9247 8.01895C10.6452 7.71325 10.6664 7.23885 10.9721 6.95935Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSausage);
export default __webpack_public_path__ + "static/media/sausage.fd358be86f003e71aade79c7f58c4a36.svg";
export { ForwardRef as ReactComponent };